import React from 'react';

import { CheckBoxContainer, Container, Content, Label, Padding } from './CheckBox.styles';
import { CheckBoxProps } from './CheckBox.types';

export const CheckBox: React.FC<CheckBoxProps> = ({
  id,
  style,
  label,
  checked,
  onChange,
  updateChecked,
  disabled,
  bordered,
  content,
  side = 'right',
  ...props
}) => {
  const handleChange = event => {
    if (disabled) return;
    onChange && onChange(event);
    updateChecked && updateChecked(!checked);
  };

  return (
    <Container
      data-testid={id || 'checkbox'}
      style={style}
      checked={checked}
      disabled={disabled}
      bordered={bordered}
      onClick={handleChange}
    >
      <Padding bordered={bordered}>
        <CheckBoxContainer disabled={disabled} side={side} hasContent={!!content}>
          <input
            id={id ?? 'input-checkbox-type'}
            type="checkbox"
            name="input-checkbox-type"
            checked={checked}
            onChange={handleChange}
            disabled={disabled}
            {...props}
          />
          <label htmlFor={id ?? 'input-checkbox-type'} onChange={handleChange}>
            <Label>{label}</Label>
            {content && <Content>{content}</Content>}
          </label>
        </CheckBoxContainer>
      </Padding>
    </Container>
  );
};
